/* eslint-disable @atlassian/tangerine/import/no-restricted-paths, @atlassian/tangerine/import/no-parent-imports */
import withEvents from '../../controllers/engagement-with-events';
import withMessage from '../../controllers/engagement-with-message';
import ContextualSurvey from '../contextual-survey-with-transition';
var ContextualSurveyWithEvents = withEvents(ContextualSurvey);
export { ContextualSurvey, ContextualSurveyWithEvents };
export default withMessage(ContextualSurveyWithEvents, 'contextualSurvey');